import { isEmpty } from 'ramda';
import { compareValues } from 'helpers/singleClassReport';
import { HARD_CODE_ORDER_COUNTRY } from 'constants/curriculum';
import {
  FETCH_USER_CURRICULUMS_REQUEST,
  FETCH_USER_CURRICULUMS_SUCCESS,
  FETCH_USER_CURRICULUMS_FAILED,
  SELECTED_CURRICULUM
} from './actionTypes';

const initialState = {
  curriculums: [],
  selectedCurriculum: {},
  isLoading: false,
  error: ''
};

// Helper to sort curriculums based on CountryId order and name
export const sortCurriculums = (curriculumsArray, countryId) => {
  const orderMap = countryId ? HARD_CODE_ORDER_COUNTRY[countryId] : null;
  let sortedData;

  if (orderMap) {
    // Combine two sorting methods: prioritize CountryId's CurriculumID order, undefined items sorted by name
    sortedData = [...curriculumsArray].sort((a, b) => {
      const orderA = orderMap[a.CurriculumID];
      const orderB = orderMap[b.CurriculumID];

      // If both are in orderMap, use orderMap order (orderMap takes priority over IsDefault)
      if (orderA !== undefined && orderB !== undefined) {
        return orderA - orderB;
      }

      // If only one is in orderMap, the one in orderMap takes priority
      if (orderA !== undefined) return -1;
      if (orderB !== undefined) return 1;

      // If both are not in orderMap, sort by name
      return compareValues('CurriculumName', 'asc')(a, b);
    });
    sortedData = [...sortedData].map((item, i) => ({
      ...item,
      IsDefault: i === 0
    }))
    // orderMap sorting takes priority over IsDefault, so don't move IsDefault to the front
    // Only move IsDefault to the front when there's no orderMap
  } else {
    // If no orderMap, use default sorting logic (sort by name)
    sortedData = [...curriculumsArray].sort(compareValues('CurriculumName', 'asc'));

    // Move IsDefault to the front (only when there's no orderMap)
    const defaultIndex = sortedData.findIndex(curr => curr.IsDefault === true);
    if (defaultIndex !== -1 && defaultIndex !== 0) {
      const tempCurriculum = sortedData[defaultIndex];
      sortedData[defaultIndex] = sortedData[0];
      sortedData[0] = tempCurriculum;
    }
  }
  return sortedData;
};

const setDefaultCurriculum = curriculumsArray => {
  const sortedCurriculums = curriculumsArray.sort(
    compareValues('CurriculumName', 'asc')
  );
  const defaultCurriculumIndex = sortedCurriculums.findIndex(
    curr => curr.IsDefault === true
  );
  if (defaultCurriculumIndex !== -1) {
    return sortedCurriculums[defaultCurriculumIndex];
  }
  return sortedCurriculums[0];
};

export default function curriculums(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_CURRICULUMS_REQUEST:
      return { ...state, isLoading: true };
    case FETCH_USER_CURRICULUMS_SUCCESS:
      // Perform all sorting logic in reducer (based on CountryId and name)
      const sortedCurriculums = sortCurriculums(
        action.curriculums,
        action.countryId
      );
      return {
        ...state,
        curriculums: sortedCurriculums,
        selectedCurriculum: isEmpty(state.selectedCurriculum)
          ? setDefaultCurriculum(sortedCurriculums)
          : state.selectedCurriculum
      };
    case FETCH_USER_CURRICULUMS_FAILED:
      return { ...state, isLoading: false, error: action.error };
    case SELECTED_CURRICULUM:
      return { ...state, selectedCurriculum: action.selectedCurriculum };
    default:
      return state;
  }
}
